// extracted by mini-css-extract-plugin
export var darkBlue = "#003e52";
export var darkGreen = "#3b693d";
export var green = "#3dae2b";
export var lightGreen = "#93d500";
export var newsGreen = "#ecf5d7";
export var orange = "#f90";
export var yellow = "#fbc900";
export var paleBlue = "#64a1bb";
export var blue = "#67b9e8";
export var blueishGrey = "#adc6d6";
export var coolGrey = "#e1e2e0";
export var white = "#fff";
export var almostWhite = "#f2eded";
export var lightGrey = "#d3d3d3";
export var lightishGrey = "#aba9a9";
export var grey = "#828382";
export var darkishGrey = "#666";
export var darkGrey = "#4b4d4b";
export var almostBlack = "#333";
export var error = "#ff3a3a";
export var warning = "#ffd162";
export var success = "#1ebc7b";
export var card = "ProductCard-module--card--tZ5Ih";
export var blexiaBrand = "ProductCard-module--blexiaBrand--1DZTV";
export var blexiaBar = "ProductCard-module--blexiaBar--1PL1s";
export var blexiaLogo = "ProductCard-module--blexiaLogo--32yo9";
export var title = "ProductCard-module--title--18N29";
export var colorBarWrapper = "ProductCard-module--colorBarWrapper--25vvw";
export var cardContent = "ProductCard-module--cardContent--1JCC3";
export var contentRow = "ProductCard-module--contentRow--1S8E5";
export var hidden = "ProductCard-module--hidden--3DbtI";
export var activeSubstancesMock = "ProductCard-module--activeSubstancesMock--3gP_c";
export var imageTitleContainer = "ProductCard-module--imageTitleContainer--38Kcq";
export var imageTitle = "ProductCard-module--imageTitle--sKuSb";
export var infoBlock = "ProductCard-module--infoBlock--1SNtF";
export var label = "ProductCard-module--label--2zTQ6";
export var info = "ProductCard-module--info--2TYEb";